import MuiButton from '@mui/material/Button';
import MuiButtonBase from '@mui/material/ButtonBase';
import MuiCheckbox from '@mui/material/Checkbox';
import MuiFormControl from '@mui/material/FormControl';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import MuiIconButton from '@mui/material/IconButton';
import MuiInputAdornment from '@mui/material/InputAdornment';
import MuiInputLabel from '@mui/material/InputLabel';
import MuiMenuItem from '@mui/material/MenuItem';
import MuiRadio from '@mui/material/Radio';
import MuiRadioGroup from '@mui/material/RadioGroup';
import MuiSwitch from '@mui/material/Switch';
import MuiTextField from '@mui/material/TextField';
import MuiToggleButton from '@mui/material/ToggleButton';
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { wrap } from '../wrap';

export const Button = wrap(MuiButton, 'Button', { size: true, tone: true, emphasis: 'button' });
export const IconButton = wrap(MuiIconButton, 'IconButton', { size: true, tone: true });
export const ButtonBase = wrap(MuiButtonBase, 'ButtonBase');

export const TextField = wrap(MuiTextField, 'TextField', {
  size: true, tone: true,
  slots: { inputProps: 'htmlInput', InputProps: 'input', InputLabelProps: 'inputLabel' },
});
export const MenuItem = wrap(MuiMenuItem, 'MenuItem');

export const Checkbox = wrap(MuiCheckbox, 'Checkbox', {
  size: true, tone: true, slots: { inputProps: 'input' },
});
export const Radio = wrap(MuiRadio, 'Radio', {
  size: true, tone: true, slots: { inputProps: 'input' },
});
export const RadioGroup = wrap(MuiRadioGroup, 'RadioGroup');
export const Switch = wrap(MuiSwitch, 'Switch', {
  size: true, tone: true, slots: { inputProps: 'input' },
});

export const FormControl = wrap(MuiFormControl, 'FormControl', { size: true, tone: true });
export const FormControlLabel = wrap(MuiFormControlLabel, 'FormControlLabel');
export const InputLabel = wrap(MuiInputLabel, 'InputLabel', { size: true, tone: true });
export const InputAdornment = wrap(MuiInputAdornment, 'InputAdornment', { keep: ['position'] });

export const ToggleButton = wrap(MuiToggleButton, 'ToggleButton', { size: true, tone: true });
export const ToggleButtonGroup = wrap(MuiToggleButtonGroup, 'ToggleButtonGroup', { size: true, tone: true });

export { Select } from './Select';
export type { SelectOwnProps } from './Select';
export { Autocomplete } from './Autocomplete';
export type { AutocompleteOwnProps } from './Autocomplete';

export type { SelectChangeEvent } from '@mui/material/Select';
